import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    marginLeft: 0,
    marginTop: "20px",
    paddingBottom: "10px",
    paddingLeft: 0,
    paddingRight: 0,
    maxWidth: "500px",
    marginBottom: "80px",
  },
  titleSpacing: {
    padding: "20px 20px 0px 20px",
  },
  title: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
  spacing: {
    padding: "20px",
  },
  section: {
    marginBottom: "20px",
    borderRadius: "5px",
    backgroundColor: theme.palette.events.grayShade2,
    border: "1px solid",
    borderColor: theme.palette.events.grayShade1,
  },
  bottomBorder: {
    "&:after": {
      position: "absolute",
      bottom: "8px",
      left: 0,
      right: 0,
      height: "1px",
      content: "",
      backgroundColor: theme.palette.gray.light,
    },
  },
  highlight: {
    animation: "$highlightPaper 1 5s linear",
  },
  spinner: {
    marginLeft: "10px",
  },
  progress: {
    marginLeft: "10px",
    color: theme.palette.events.whiteTertiary,
  },
  split: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  splitHorizontallyCentered: {
    alignItems: "center",
  },
  description: {
    marginTop: "20px",
    fontWeight: 100,
    lineHeight: "18px",
  },
  infoDescription: {
    marginTop: "5px",
  },
  descriptionSpacingBottom: {
    marginBottom: "20px",
  },
  infoBox: {
    padding: "10px",
    display: "flex",
    backgroundColor: theme.palette.events.blueShade2,
    borderRadius: "5px",
    margin: "20px 0px",
    alignItems: "center",
  },
  infoBoxText: {
    paddingLeft: "15px",
  },
  darkIcon: {
    display: "flex",
    color: theme.palette.events.bluePrimary,
  },
  inputContainer: {
    marginBottom: "20px",
    "& .MuiFormHelperText-root": {
      color: `${theme.palette.events.bluePrimary} !important`,
      fontSize: "10px",
      fontWeight: 500,
    },
    "& .MuiInputBase-input": {
      color: theme.palette.text.primary,
    },
    "& .Mui-error": {
      color: `${theme.palette.error.main} !important`,
    },
    "& .MuiInputBase-root.Mui-error": {
      borderColor: theme.palette.error.main,
    },
  },
  actionContainer: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "20px",
  },
  actionButton: {
    "&:not(:first-child)": {
      marginInlineStart: "10px",
    },
  },
  readonlyField: {
    "&:not(:last-child)": {
      marginBottom: "20px",
    },
  },
  bottomSpacedText: {
    paddingBottom: "5px",
    wordBreak: "break-all",
  },
  headSpace: {
    marginTop: "10px",
  },
  samlSampleButton: {
    marginTop: "10px",
    marginBottom: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  "@keyframes highlightPaper": {
    "0%": {
      boxShadow: "0 1px 8px rgba(255, 208, 36, 0.6)",
    },
    "70%": {
      boxShadow: "0 1px 8px rgba(255, 208, 36, 0.6)",
    },
    "100%": {
      boxShadow: "0 1px 8px transparent",
    },
  },
}));

export const styles = {
  dialogContent: {
    width: "494px",
    padding: "20px !important",
  },
  dialogCloseIcon: {
    color: "icon.secondary",
  },
  disableBtn: {
    width: "129px",
  },
  cancelBtn: {
    width: "127px",
  },
};
